export const loadingLabel = "Lba";
export default {loadingLabel};